module.exports = function (Component) {
  Component.options.__i18n = Component.options.__i18n || []
  Component.options.__i18n.push('{"en-BE":{"close":"Close"},"fr-BE":{"close":"Fermer"},"nl-BE":{"close":"Sluiten"}}')
  delete Component.options._Ctor
}
